import React from 'react';
import './index.scss';

const TermsConditions = () => {
  return (
    <section className="terms-container">
      <span className="terms-container__updated">Last updated: 31st March 2023</span>
      <h1 className="terms-container__heading">Staking Terms and Conditions</h1>
      <ol className="terms-container__list">
        <li>
          <h3>Eligibility for Staking</h3>
          <p>
            The MagicCraft Staking Program (the "Program") is open to all individuals and entities who hold
            $MCRT tokens. To be eligible to participate in the Program, you must be at least 18 years old,
            have full legal capacity and not be prohibited by any laws or regulations from holding or staking
            $MCRT tokens. You must also comply with all applicable laws and regulations in your jurisdiction.
            By participating in the Program, you confirm that you meet these eligibility requirements and
            accept these Terms and Conditions.
          </p>
          <p>
            Please note that the program may be subject to change without notice and could be restricted in
            certain countries based on regulatory requirements. MagicCraft retains the right to require users
            to disclose their complete details as part of its know-your-customer (KYC) obligations.
          </p>
        </li>
        <li>
          <h3>Staking Duration and Renewal</h3>
          <p>
            Users of the MagicCraft Staking Program (the "Program") will be able to select a staking term of
            their choosing when they participate in the program. The staking term options will be provided on
            the MagicCraft website and may be subject to change at the discretion of MagicCraft.
          </p>
          <p>
            Once you have selected your staking term and locked your tokens, the staking period will begin on
            the date that you stake your $MCRT tokens. At the end of the chosen staking term, your staked
            tokens will be automatically released back to your connected wallet, and you will be eligible to
            receive the corresponding staking rewards.
          </p>
          <p>
            It's important to note that the user will be able to select a staking term of their choosing, but
            they must be aware that if they choose to renew their staking term, they will have to redeposit
            their tokens. Also, the company reserves the right to change the staking term options offered in
            the Program but will provide advance notice of any such changes to the users.
          </p>
        </li>
        <li>
          <h3>Return on Staked Tokens</h3>
          <p>
            The return on staked tokens will be determined by MagicCraft and may vary based on a number of
            factors, including the total amount of $MCRT tokens staked in the Program, the total supply of
            $MCRT tokens, and market conditions. MagicCraft will provide an estimated annual return on staked
            tokens, but please note that the actual return may be higher or lower than the estimate. MagicCraft
            does not guarantee any specific return on staked tokens and the return is subject to change at any
            time.
          </p>
        </li>
        <li>
          <h3>Token Custody and Investment Decisions</h3>
          <p>
            MagicCraft does not take custody of your staked $MCRT tokens, nor does it make any investment
            decisions regarding the tokens. The staking program is conducted through a smart contract on the
            Binance Smart Chain, which automatically determines the staking rewards based on the total amount
            of $MCRT tokens staked and market conditions.
          </p>
          <p>
            By participating in the Program, you acknowledge and accept that your staked tokens are not pooled
            with those of other users and are not used by MagicCraft to make any investments. Your staked tokens
            are simply temporarily locked in a smart contract address on the Binance Smart Chain, and you retain
            full ownership of your staked $MCRT tokens throughout the staking period.
          </p>
        </li>
        <li>
          <h3>Risk Disclaimer</h3>
          <p>
            MagicCraft is not responsible for any losses, damages, or costs that you may incur as a result of
            staking your $MCRT tokens in the Program. By participating in the Program, you acknowledge and
            accept that the rewards generated from staking on the Binance Smart Chain are determined by the
            smart contract, and that MagicCraft has no control over the rewards or the market conditions
            affecting the value of $MCRT tokens.
          </p>
        </li>
        <li>
          <h3>Dispute Resolution</h3>
          <p>
            These Terms and Conditions and the Program shall be governed by and construed in accordance with the
            laws of Singapore. Any dispute arising out of or related to the Program or the use of $MCRT tokens
            shall be resolved through good faith negotiation and discussion. If the dispute cannot be resolved
            through negotiation, it shall be submitted to mediation in Singapore in accordance with the mediation
            rules of the Singapore International Mediation Centre. If the dispute is not resolved through
            mediation, it shall be submitted to and finally resolved by arbitration in Singapore in accordance
            with the Arbitration Rules of the Singapore International Arbitration Centre, with the decision of
            the arbitrator being final and binding on the parties.
          </p>
        </li>
        <li>
          <h3>Miscellaneous Provisions</h3>
          <p>
            <strong>Entire Agreement:</strong> These Terms and Conditions constitute the entire agreement between you and
            MagicCraft with respect to the Program and supersede all prior or contemporaneous communications and
            proposals, whether oral or written, between you and MagicCraft.
          </p>
          <p>
            <strong>Waiver and Severability:</strong> The failure of MagicCraft to enforce any right or provision in these Terms
            and Conditions shall not constitute a waiver of such right or provision unless acknowledged and agreed
            to by us in writing. In the event that any provision of these Terms and Conditions is held to be
            invalid or unenforceable, the remaining provisions of these Terms and Conditions will remain in full
            force and effect.
          </p>
          <p>
            <strong>Assignment:</strong> You may not assign or transfer your rights or obligations under these Terms and
            Conditions without the prior written consent of MagicCraft, and any unauthorized assignment and
            transfer by you is null and void. MagicCraft may assign or transfer its rights or obligations under
            these Terms and Conditions without your prior written consent.
          </p>
          <p>
            <strong>Language:</strong> The parties confirm that it is their wish that these Terms and Conditions and all related
            documents be drawn up in English.
          </p>
        </li>
      </ol>
    </section>
  );
};

export default TermsConditions; 